export function splitCamel(camel: string) {
  return camel.replace(/([A-Z])/g, ' $1');
}

export function capitalize(str: string) {
  return str.replace(/^./, (s: string) => s.toUpperCase());
}

export function capitalizeCamel(camel: string) {
  const splitted = splitCamel(camel);
  return capitalize(splitted);
}
